// models/UserModel.js
export class ForgotModel {
    constructor(email_id) {
      this.email_id = email_id;
    }
  }
  